import Icon from '../../components/Icon.vue'

Icon.register({
  'brands/gitlab': {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M105.2 24.9c0 0 56.5 174.8 56.6 174.8h-132l56.5-174.8c3.2-8.9 15.8-8.9 18.9 0zM0.9 287.7l28.8-88 226.2 294-247.9-184c-6.8-5.1-9.7-14-7.1-22zM161.7 199.7h188.6l-94.3 294zM511.1 287.7c2.5 8-0.3 16.9-7.2 22l-247.9 184 226.3-294zM425.7 24.9l56.5 174.8h-132l56.6-174.8c3.2-8.9 15.8-8.9 18.9 0z'
      }
    ]
  }
})
